import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";

import { toast } from "react-toastify";
import { BASE_URL_IMG } from "../../assets/constants";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";

import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { useForm } from "react-hook-form";
import ImageUpload from "../ImageFolder/ImageUpload";

import { createDiseaseAPI, listDiseaseAPI, updateDiseaseAPI } from "../../api/master/indes";

import MyInput from "../../MyComp/UI/form/MyInput";
import ViewImgAndPdf from "../ImageFolder/ViewImageAndPdf";
import useLogout from "../../hooks/useLogout";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";

const Disease = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Table Columns
  const [column, setColumn] = useState([
   
    {
      name: "Image",
      selector: (row) => (
        <div  >
          {/* <img
            style={{ width: "50px", height: "50px", borderRadius: "6px" }}
            src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
          /> */}
           <UserAvatarCell row={row} name={row?.name} handleImageOpenPreview={handleImageOpenPreview} image={`${BASE_URL_IMG}${row.image}`}/>
          
        </div>
      ),
      sortable: false,
      wrap: true,
    },
     {
      name: "Disease",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>
        </div>
      ),
    },
  ]);

  // Fetch disease list
  useEffect(() => {
    getDiseaseList();
  }, []);

  const getDiseaseList = async () => {
    try {
      const res = await listDiseaseAPI();
      if (res.data.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
      } else if (res.data.status === true) {
        setValue("data", res.data.data);
      } else {
        setValue("data", []);
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
    }
  };

  const onFormSubmit = async (data) => {
    try {
      setValue("isLoading", true);
      const formData = new FormData();

      formData.append("status", watch("status")?.value);
      const i = watch("disease_img");
      if (data?.disease_img) {
        formData.append("img", i);
      }

      if (watch("addSub")) {
        formData.append("parent_id", data?.sub_disease ? data?.sub_disease?.value : watch("selectedRow")?.id);
        formData.append("name", watch("subdisease"));
      } else {
        formData.append("name", watch("disease"));
      }

      if (mode === "Edit") {
        formData.append("id", watch("selectedRow")?.id);
      }

      let res;
      if (mode === "Add") {
        res = await createDiseaseAPI(formData);
      } else {
        res = await updateDiseaseAPI(formData);
      }

      if (res?.data?.status === true) {
        toast.success(res.data.message);
        toast.clearWaitingQueue();
        await getDiseaseList();
        getDiseaseList();
        resetF();
        setIsOpen(false);
      } else if (res?.data?.status === "expired") {
        toast.error(res.data.message);
        logout();
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setValue("isLoading", false);
    }
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("disease", row?.name);
    const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("disease_image", imageUrl);
    setValue("disease_img", imageUrl);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };

    try {
      const res = await updateDiseaseAPI(formObject);
      if (res.data.status === true) {
        toast.success(res.data.message);
        await getDiseaseList();
      } else if (res.data.status === "expired") {
        toast.error(res.data.message);
        logout();
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
   
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const handleSubdiseaseClick = (row) => {
    window.scrollTo(0, 0);
    setIsOpen(true);
    setMode("Add");
    setValue("addSub", true);
    setValue("selectedRow", row);
    setValue("disease", row?.name);
    setValue("disease_image", row.image);
    setValue("disease_img", row.image);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
  };

  const resetF = () => {
    setValue("disease_image", null);
    setValue("disease", "");
    setValue("status", null);
    setValue("addSub", false);
    setValue("disease_img", null);
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };

  return (
    <>
      <Head title="Disease | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Disease
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  setIsOpen((pre) => !pre);
                  setMode("Add");
                  resetF();
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Disease"
                      name="disease"
                      placeholder="Enter disease name"
                      required
                      min={2}
                      max={50}
                      disabled={watch("addSub")}
                    />
                  </Col>

                  <Col md="4">
                    <ImageUpload
                      name="disease_img"
                      id="disease_image"
                      watch={watch}
                      label="Upload Disease Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="disease_img"
                      image_url="disease_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>

                  <Col md="4">
                    <Status
                      title={"Status"}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title="Disease List" isLoading={isLoading} />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />

      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
    </>
  );
};

export default Disease;
